import type { TranslationDict } from '../en';

const el: TranslationDict = {
  // ─── Header ───
  'header.buy': 'Αγορά',
  'header.sell': 'Πώληση',

  // ─── SpendCard ───
  'spend.label': 'Πληρώνεις',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',

  // ─── ReceiveCard ───
  'receive.label': 'Λαμβάνεις',

  // ─── PaymentCard ───
  'payment.label': 'Τρόπος πληρωμής',
  'payment.select': 'Επιλογή',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Δεν υπάρχουν τρόποι πληρωμής για αυτό το ζεύγος',

  // ─── WalletCard ───
  'wallet.label': 'Διεύθυνση πορτοφολιού λήψης',
  'wallet.placeholderBuy': 'Εισάγετε τη διεύθυνση λήψης σας',
  'wallet.placeholderSell': 'Εισάγετε τη διεύθυνση αποστολής σας',
  'wallet.validating': 'Επαλήθευση διεύθυνσης...',
  'wallet.invalid': 'Εισάγετε έγκυρη διεύθυνση πορτοφολιού',
  'wallet.invalidServer': 'Μη έγκυρη διεύθυνση πορτοφολιού',

  // ─── CtaButton ───
  'cta.buy': 'Αγορά {crypto}',
  'cta.sell': 'Πώληση {crypto}',
  'cta.gettingPrice': 'Εύρεση καλύτερης τιμής...',
  'cta.processing': 'Επεξεργασία...',

  // ─── Footer ───
  'footer.poweredBy': 'Με την υποστήριξη της ',
  'footer.brand': 'NowRamp',

  // ─── Rate Breakdown ───
  'rate.title': 'Ανάλυση ισοτιμίας',
  'rate.close': 'Κλείσιμο',
  'rate.updatesIn': 'Η ισοτιμία ενημερώνεται σε 00:{seconds}',
  'rate.noQuote': 'Δεν υπάρχει διαθέσιμη προσφορά',
  'rate.exchangeRate': 'Ισοτιμία',
  'rate.processingFee': 'Προμήθεια επεξεργασίας',
  'rate.networkFee': 'Προμήθεια δικτύου',
  'rate.provider': 'Πάροχος',

  // ─── Toast ───
  'toast.orderCreated': 'Η παραγγελία δημιουργήθηκε',
  'toast.redirecting': 'Ανακατεύθυνση στο ταμείο...',
  'toast.orderFailed': 'Η παραγγελία απέτυχε',
  'toast.couldNotCreate': 'Δεν ήταν δυνατή η δημιουργία παραγγελίας',
  'toast.quoteError': 'Σφάλμα προσφοράς',
  'toast.noProviders': 'Δεν υπάρχουν πάροχοι',
  'toast.somethingWrong': 'Κάτι πήγε στραβά',

  // ─── Form errors ───
  'error.amountZero': 'Το ποσό πρέπει να είναι μεγαλύτερο από 0',
  'error.minAmountFiat': 'Ελάχιστο ποσό είναι {min} {currency}',
  'error.minAmountCrypto': 'Ελάχιστο ποσό είναι {min} {currency}',
  'error.noProviders': 'Δεν υπάρχουν διαθέσιμοι πάροχοι για αυτόν τον συνδυασμό',
  'error.currencyUnavailableBuy': 'Αυτό το νόμισμα δεν είναι διαθέσιμο για αγορές',
  'error.currencyUnavailableSell': 'Αυτό το νόμισμα δεν είναι διαθέσιμο για πωλήσεις',

  // ─── Parity banner ───
  'parity.info': 'Θα χρεωθείτε για {receiveAmount} {crypto}, το υπόλοιπο έως {spendAmount} {fiat} θα πιστωθεί στον λογαριασμό σας {partner}',

  // ─── Redirect Screen ───
  'redirect.secureBadge': 'Ασφαλής πληρωμή',
  'redirect.title': 'Συνέχεια πληρωμής',
  'redirect.description': 'Θα ανακατευθυνθείτε στο {gateway} για να ολοκληρώσετε την πληρωμή σας.',
  'redirect.countdown': 'Ανακατεύθυνση σε {seconds}...',
  'redirect.openTab': 'Άνοιγμα ACH σε νέα καρτέλα',
  'redirect.cancel': 'Ακύρωση',

  // ─── Checkout Step ───
  'checkout.noOrder': 'Δεν βρέθηκε παραγγελία',
  'checkout.goBack': 'Πίσω',
  'checkout.expired': 'Το ταμείο έληξε',
  'checkout.expiredDesc': 'Η συνεδρία έχει λήξει. Παρακαλώ δοκιμάστε ξανά.',
  'checkout.startOver': 'Εκ νέου έναρξη',
  'checkout.cancel': 'Ακύρωση',
  'checkout.loading': 'Φόρτωση ταμείου...',
  'checkout.iframeTitle': 'Ταμείο παρόχου',
  'checkout.widgetTitle': 'Ταμείο πληρωμής',
  'checkout.unknownMethod': 'Άγνωστη μέθοδος ταμείου',

  // ─── Processing Step ───
  'processing.default': 'Η παραγγελία σας επεξεργάζεται...',
  'processing.pending': 'Αναμονή επιβεβαίωσης πληρωμής...',
  'processing.active': 'Η συναλλαγή σας επεξεργάζεται...',
  'processing.generic': 'Επεξεργασία...',
  'processing.checkingStatus': 'Έλεγχος κατάστασης...',
  'processing.orderId': 'Αριθμός παραγγελίας',
  'processing.provider': 'Πάροχος',
  'processing.amount': 'Ποσό',
  'processing.receiving': 'Λήψη',
  'processing.network': 'Δίκτυο',
  'processing.toAddress': 'Διεύθυνση προορισμού',
  'processing.usuallyMinutes': 'Αυτό συνήθως διαρκεί λίγα λεπτά.',
  'processing.safeToClose': 'Μπορείτε να κλείσετε αυτή τη σελίδα με ασφάλεια – θα σας στείλουμε email όταν ολοκληρωθεί.',

  // ─── Complete Step ───
  'complete.buyTitle': 'Η αγορά ολοκληρώθηκε!',
  'complete.sellTitle': 'Η πώληση ολοκληρώθηκε!',
  'complete.buyDesc': 'Το {crypto} σας έχει σταλεί στο πορτοφόλι σας.',
  'complete.sellDesc': 'Η πληρωμή σας σε {fiat} επεξεργάζεται.',
  'complete.amountBuy': 'Ποσό που ελήφθη',
  'complete.amountSell': 'Ποσό που πωλήθηκε',
  'complete.paidBuy': 'Ποσό που καταβλήθηκε',
  'complete.paidSell': 'Ποσό πληρωμής',
  'complete.network': 'Δίκτυο',
  'complete.wallet': 'Πορτοφόλι',
  'complete.transaction': 'Συναλλαγή',
  'complete.provider': 'Πάροχος',
  'complete.orderId': 'Αριθμός παραγγελίας',
  'complete.completed': 'Ολοκληρώθηκε',
  'complete.viewExplorer': 'Προβολή στο Explorer',
  'complete.done': 'Τέλος',

  // ─── Error Step ───
  'errorStep.failed': 'Η πληρωμή απέτυχε',
  'errorStep.cancelled': 'Η παραγγελία ακυρώθηκε',
  'errorStep.expired': 'Η παραγγελία έληξε',
  'errorStep.refunded': 'Η παραγγελία επιστράφηκε',
  'errorStep.unknown': 'Κάτι πήγε στραβά',
  'errorStep.failedBuy': 'Η πληρωμή σας δεν ήταν δυνατό να επεξεργαστεί. Παρακαλώ δοκιμάστε ξανά ή χρησιμοποιήστε διαφορετικό τρόπο πληρωμής.',
  'errorStep.failedSell': 'Η πώλησή σας δεν ήταν δυνατό να επεξεργαστεί. Παρακαλώ δοκιμάστε ξανά.',
  'errorStep.cancelledBuy': 'Η παραγγελία σας ακυρώθηκε. Δεν επεξεργάστηκε καμία πληρωμή.',
  'errorStep.cancelledSell': 'Η πώλησή σας ακυρώθηκε. Δεν μεταφέρθηκε κρυπτονόμισμα.',
  'errorStep.expiredBuy': 'Η παραγγελία σας έχει λήξει. Παρακαλώ ξεκινήστε μια νέα αγορά.',
  'errorStep.expiredSell': 'Η παραγγελία σας έχει λήξει. Παρακαλώ ξεκινήστε μια νέα πώληση.',
  'errorStep.refundedBuy': 'Η πληρωμή σας έχει επιστραφεί. Τα χρήματα θα εμφανιστούν στον λογαριασμό σας εντός 5–10 εργάσιμων ημερών.',
  'errorStep.refundedSell': 'Το κρυπτονόμισμά σας έχει επιστραφεί. Τα χρήματα θα εμφανιστούν στο πορτοφόλι σας σύντομα.',
  'errorStep.genericDesc': 'Παρουσιάστηκε απροσδόκητο σφάλμα. Παρακαλώ δοκιμάστε ξανά.',
  'errorStep.orderId': 'Αριθμός παραγγελίας',
  'errorStep.tryAgain': 'Προσπαθήστε ξανά',
  'errorStep.startOver': 'Εκ νέου έναρξη',
  'errorStep.return': 'Επιστροφή',
  'errorStep.needHelp': 'Χρειάζεστε βοήθεια; Επικοινωνήστε ',
  'errorStep.reference': 'Αναφορά: {orderId}',

  // ─── Confirm Step ───
  'confirm.buyTitle': 'Επιβεβαίωση αγοράς',
  'confirm.sellTitle': 'Επιβεβαίωση πώλησης',
  'confirm.loading': 'Φόρτωση...',
  'confirm.provider': 'Πάροχος',
  'confirm.youPay': 'Πληρώνεις',
  'confirm.youSell': 'Πουλάς',
  'confirm.youReceive': 'Λαμβάνεις',
  'confirm.wallet': 'Πορτοφόλι',
  'confirm.network': 'Δίκτυο',
  'confirm.refundAddress': 'Διεύθυνση επιστροφής',
  'confirm.parityNote': 'Το χρεωθέν ποσό από τον πάροχο ενδέχεται να διαφέρει. Το υπόλοιπο έως {amount} {crypto} θα πιστωθεί στον λογαριασμό σας {partner}.',
  'confirm.processing': 'Επεξεργασία...',
  'confirm.confirmPay': 'Επιβεβαίωση και πληρωμή',
  'confirm.confirmSell': 'Επιβεβαίωση και πώληση',
  'confirm.payout': 'Πληρωμή σε {currency}',

  // ─── Modals ───
  'modal.selectFiat': 'Επιλογή νομίσματος fiat',
  'modal.selectCrypto': 'Επιλογή κρυπτονομίσματος',
  'modal.choosePayment': 'Επιλογή τρόπου πληρωμής',
  'modal.selectCountry': 'Επιλέξτε τη χώρα σας',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Δημοφιλή',
  'modal.recommended': 'Προτεινόμενα',
  'modal.noCurrencies': 'Δεν βρέθηκαν νομίσματα',
  'modal.noPaymentMethods': 'Δεν βρέθηκαν τρόποι πληρωμής',
  'modal.noCountries': 'Δεν βρέθηκαν χώρες',
  'modal.noLanguages': 'No languages found',

  // ─── Settings ───
  'settings.location': 'Τοποθεσία',
  'settings.darkMode': 'Σκοτεινή λειτουργία',
  'settings.privacy': 'Πολιτική απορρήτου',
  'settings.terms': 'Όροι χρήσης',
  'settings.language': 'Γλώσσα',

  // ─── Additional ───
  'modal.chooseRamp': 'Επιλογή Ramp',
  'modal.bestPrice': 'Καλύτερη τιμή',
  'modal.noQuotes': 'Δεν υπάρχουν διαθέσιμες προσφορές για αυτό το αίτημα',
  'modal.noProvidersFound': 'Δεν βρέθηκαν πάροχοι',
  'payment.unavailableFor': 'Δεν υπάρχουν τρόποι πληρωμής για {currency}',
  'skeleton.poweredBy': 'Με την υποστήριξη της NowRamp',
  'error.createOrderFailed': 'Αποτυχία δημιουργίας παραγγελίας',
  'errorStep.returnToMerchant': 'Επιστροφή στον έμπορο',
  'confirm.cryptoOnNetwork': '{crypto} στο {network}',
  'payment.name.card': 'Κάρτα',
  'payment.name.bankTransfer': 'Τραπεζική Μεταφορά',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default el;
